import { Link } from 'react-router-dom';

import { ContactForm } from '../../components/contact-form';

export default function Calculators() {
  return (
    <div>
      <section className="relative overflow-hidden py-16" style={{ background: "var(--gradient-hero)" }}>
        <div className="pointer-events-none absolute inset-0">
          <div className="aurora" />
          <div className="noise" />
        </div>
        <div className="container-ivalue relative">
          <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">Resources / Calculators</div>
          <h1 className="mt-4 text-balance text-4xl font-extrabold tracking-[-0.03em] text-text-primary md:text-6xl">
            Calculators
            <br />
            for compliance ROI and risk
          </h1>
          <p className="mt-5 max-w-3xl text-lg leading-relaxed text-text-secondary">
            Quick estimation tools: penalty exposure, readiness, evidence automation ROI, and audit cost reduction.
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link to="/dashboards" className="focus-ring sheen inline-flex h-12 items-center justify-center rounded-xl bg-gradient-to-r from-[#3B82F6] to-[#1D4ED8] px-5 text-sm font-semibold text-white hover:opacity-95">
              View dashboards →
            </Link>
            <Link to="/resources" className="focus-ring inline-flex h-12 items-center justify-center rounded-xl border border-border-subtle bg-white/5 px-5 text-sm font-semibold text-text-primary hover:bg-white/10">
              Back to resources
            </Link>
          </div>
        </div>
      </section>

      <section className="bg-background-primary py-20">
        <div className="container-ivalue">
          <div className="grid gap-4 lg:grid-cols-2">
            {[ 
              {
                t: "DPDPA penalty exposure estimator",
                d: "Estimate exposure across Tier-1 to Tier-4 scenarios based on breach likelihood and coverage gaps.",
                href: "/frameworks/india/dpdpa#penalties",
              },
              {
                t: "Evidence automation ROI",
                d: "Quantify effort reduction when moving from manual evidence to automated pipelines across SIEM/GRC/IAM.",
                href: "/technology-mapping",
              },
              {
                t: "Audit readiness score",
                d: "Score your program across controls, evidence completeness, and operational cadence.",
                href: "/assessment",
              },
              {
                t: "Third-party risk workload model",
                d: "Estimate annual vendor assessment hours by criticality, scope and reassessment frequency.",
                href: "/offerings",
              },
            ].map((x) => (
              <div key={x.t} className="glass-card sheen p-6">
                <div className="text-lg font-semibold text-text-primary">{x.t}</div>
                <div className="mt-2 text-sm text-text-secondary">{x.d}</div>
                <div className="mt-5">
                  <Link to={x.href} className="focus-ring inline-flex h-11 items-center justify-center rounded-xl border border-border-subtle bg-white/5 px-4 text-sm font-semibold text-text-primary hover:bg-white/10">
                    Open reference →
                  </Link>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 glass-card p-6">
            <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">Note</div>
            <div className="mt-3 text-sm text-text-secondary">
              These calculators are presented as templates. If you want, we can implement them as interactive inputs with charts and downloadable reports.
            </div>
          </div>

          <div className="mt-10 glass-card p-6" id="contact-form">
            <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">Request an interactive calculator</div>
            <div className="mt-3 text-sm text-text-secondary">Tell us which calculator you want and we can wire it into the dashboards layer.</div>
            <div className="mt-6">
              <ContactForm title="Calculator request" subtitle="We can deliver as a dashboard widget or standalone tool." ctaLabel="Send" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
